export default __webpack_public_path__ + "static/media/Whatsapp_green.d8b3e77e.svg";